<div class="login-banner login-hero">
  <div class="login-hero-container">
    <img class="login-hero-logo" alt="" draggable="false" [src]="'logos/nyjlogo.png' | contentAssetImage" />

    <div class="login-card">
      <h2 class="login-card-title text-secondary text-uppercase mb-0">
        {{ 'login.page.title' | translate : { fgbdefault: 'Welcome Fans' } }}
      </h2>

      <fgb-user-login></fgb-user-login>

      <ul class="footer-links">
        <li class="footer-link">
          <a href="{{ 'footer.privacy.link.url' | translate }}">
            <div class="privacy-link font-size-14">{{ 'footer.privacy.link' | translate }}</div>
          </a>
        </li>
        <li class="footer-link">
          <a href="{{ 'footer.your.privacy.link.url' | translate }}">
            <div class="privacy-link font-size-14">
              {{ 'footer.your.privacy.link' | translate }}
            </div>
          </a>
        </li>
        <li class="footer-link">
          <!-- OneTrust Cookies Settings button start -->
          <a class="privacy-link font-size-14 ot-sdk-show-settings">{{ 'footer.cookies.settings' | translate }}</a>
          <!-- OneTrust Cookies Settings button end -->
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="login-programme">
  <div class="login-programme-container">
    <div class="login-programme-intro">
      <h3 class="login-programme-title">
        {{ 'login.page.programme.title' | translate : { fgbdefault: 'Welcome to the New York Jets Programme' } }}
      </h3>
      <p class="login-programme-description mb-0">
        {{
          'login.page.programme.description'
            | translate
              : {
                  fgbdefault:
                    'Welcome to our loyalty program! Log in to explore a world of exclusive challenges tailored just for you. As you complete these challenges, you’ll earn exciting rewards. Whether it’s special discounts, unique experiences, or must-have items, your dedication pays off. Join us and start earning today!'
                }
        }}
      </p>
    </div>

    <div class="login-widgets">
      <div class="login-widget bg-glass-dark">
        <div class="login-widget-icon">
          <span class="material-symbols-outlined filled" aria-hidden="true">account_circle</span>
        </div>
        <div class="login-widget-text">
          <h4 class="login-widget-title">{{ 'login.page.signup.title' | translate : { fgbdefault: 'Sign Up' } }}</h4>
          <p class="login-widget-description mb-0">
            {{
              'login.page.signup.description'
                | translate
                  : {
                      fgbdefault:
                        'Sign up for free to receive Jets shop discounts, priority access to UK & Ireland events, exclusive offers and giveaways plus a one-week free trial of NFL Game Pass'
                    }
            }}
          </p>
        </div>
      </div>

      <div class="login-widget bg-glass-dark">
        <div class="login-widget-icon">
          <span class="material-symbols-outlined filled" aria-hidden="true">card_membership</span>
        </div>
        <div class="login-widget-text">
          <h4 class="login-widget-title">{{ 'login.page.membership.title' | translate : { fgbdefault: 'Membership' } }}</h4>
          <p class="login-widget-description mb-0">
            {{
              'login.page.membership.description'
                | translate
                  : {
                      fgbdefault:
                        'Plus, upgrade your membership to the paid MVP tier to get 15% off a season NFL Game Pass subscription, priority access to Jets tickets, exclusive virtual events and a physical membership card!'
                    }
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="login-membership-options">
      <div class="login-programme-intro">
        <h3 class="login-programme-title">
          {{ 'login.page.membership.options.title' | translate : { fgbdefault: 'Membership Options' } }}
        </h3>
        <p class="login-programme-description mb-0">
          {{
            'login.page.membership.options.description'
              | translate
                : {
                    fgbdefault:
                      'From everyday perks to court side-level access, discover membership tiers designed to bring you closer to the game.'
                  }
          }}
        </p>
      </div>

      <img
        class="login-membership-matrix"
        [alt]="
          'login.page.membership.matrix.alt'
            | translate : { fgbdefault: 'New York Jets Fan Club membership benefits by tier: Rookie and MVP' }
        "
        draggable="false"
        [src]="'banners/membership-banner.png' | contentAssetImage"
      />
    </div>
  </div>
</div>
